import React, { useMemo, useState } from 'react';
import AsyncReactSelect from 'react-select/async';
import api from 'src/api';
import { debounce } from 'src/utils/core';
import { CustomRefineComponentProps } from './definitions';
import { SurveyServerModel } from 'src/data/types/surveys/types';
import { useSurveyBare } from 'src/utils/hooks/useSurveyBare';

export function SurveysLoader(props: CustomRefineComponentProps) {
    const search = useMemo(() => debounce((input: string, callback: any) => {
        api.surveys.searchByName({ name: input }, {}).then(resp => {
            callback(resp.map(a => ({
                label: a.internalName,
                value: a.id
            })));
        })
    }, 300), []);

    const entity = useSurveyBare(props.rule.expression.val);

    const selEntity = useMemo(() => {
        if (entity) {
            return { label: entity.survey?.internalName, value: entity.survey?.id }
        } else {
            return null;
        }
    }, [entity]);

    return <AsyncReactSelect
        classNamePrefix='custom-select'
        placeholder={'Type to search...'}
        loadOptions={search}
        // defaultOptions={selEntity ? [selEntity] : null}
        value={selEntity}
        noOptionsMessage={() => 'No options loaded, type something to search'}
        //@ts-ignore
        onChange={e => props.onRuleExpressionChanged({ ...props.rule.expression, val: e.value })} />

}

export function AnnouncementsLoader() {
    return <div>
        announcements loader
    </div>
}